<section class="flex justify-between items-center my-20">
  <div class="flex items-center">
    <h4>
      {{ bucket()?.title }}
      <span [id]="bucket()?.id" class="anchor"></span>
    </h4>
    <div class="flex items-center text-neut-var-60">
      <span class="material-icons text-sm ml-20 mr-5"> sort </span>
      <p class="body-2 capitalize">{{ sortOption.label }}</p>
    </div>
  </div>

  @if (allowFilter) {
    <div class="hidden 3xl:block">
      <ng-container *ngTemplateOutlet="noFilteredJobsFound" />
    </div>
  }

  <div class="flex justify-between items-end">
    @if (allowFilter) {
      <mat-form-field class="no-validation min-w-[420px]! input-search">
        <input
          matInput
          [placeholder]="filterPlaceholder | titlecase"
          [ngModel]="filterValue()"
          (ngModelChange)="filterValue.set($event)" />
        @if (filterValue()) {
          <button matIconSuffix matIconButton aria-label="Clear" (click)="filterValue.set('')">
            <mat-icon> close </mat-icon>
          </button>
        }
        @if (!filterValue()) {
          <mat-icon matIconSuffix> filter_list </mat-icon>
        }
      </mat-form-field>
    }

    @if (allowSort) {
      <mat-form-field class="no-validation min-w-[330px]!">
        <mat-label>Sort By</mat-label>
        <mat-select
          [(value)]="sortOption"
          [compareWith]="optionComparisonFunction"
          (selectionChange)="onChangeDashboardSortOrder($event)">
          @for (option of sortOptionsList; track option) {
            <mat-option [value]="option">{{ option.label }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
</section>

@if (allowFilter) {
  <div class="mb-25 3xl:hidden">
    <ng-container *ngTemplateOutlet="noFilteredJobsFound" />
  </div>
}

@if (filteredJobs()?.length) {
  <div class="jobs-container">
    @for (
      jobBucket of filteredJobs() | orderByEpochTime: sortOption.value : sortOption.direction;
      track jobBucket.jobId
    ) {
      <app-repairer-tile
        [id]="jobBucket.jobId"
        [job]="jobBucket"
        [bucket]="bucket()?.bucketName"
        [hasRedBadge]="badgedBucket() && !jobBucket?.unsubmittedDocument"
        (getJobs)="getJobs.emit()" />
    }
  </div>
} @else {
  <div class="guidance-message-container empty-state">
    <mat-icon>error_outline</mat-icon>
    <span>{{ bucket()?.errormessage }}</span>
  </div>
}

<ng-template #noFilteredJobsFound>
  @if (hasNoMatchingJobs()) {
    <div class="flex justify-center items-center">
      <mat-icon class="mr-10">info_outline</mat-icon>
      {{ noResultFilterMessage }}
    </div>
  }
</ng-template>

@if (bucket()?.showSeparator) {
  <mat-divider class="bucket-separator" />
}
